import { styled } from '@linaria/react';

import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const MethodHeading = styled.h4`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const MethodRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${space[3]};
`;

export const MethodOption = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
  padding: ${space[3]} ${space[4]};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.white};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};

  &[data-selected='true'] {
    border-color: ${colors.fontPrimary};
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const MethodLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${space[2]};
`;

export const Radio = styled.input`
  appearance: none;
  margin: 0;
  width: 16px;
  height: 16px;
  border: 1px solid ${colors.borderGrey};
  border-radius: 50%;
  cursor: inherit;
  background: ${colors.white};
  flex-shrink: 0;

  &:checked {
    border-color: ${colors.fontPrimary};
    background: ${colors.fontPrimary};
    box-shadow: inset 0 0 0 3px ${colors.white};
  }
`;

export const MessageBox = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
`;

export const CostRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[3]} ${space[4]};
  background: ${colors.lighterGrey};
  border-radius: ${layout.borderRadius};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
`;

export const ShippingFormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;

  & > :first-child {
    padding-right: ${space[4]};
    border-right: 1px solid ${colors.borderGreyLighter};
  }

  & > :last-child {
    padding-left: ${space[4]};
  }
`;
